import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'num_of_female_wrkrs_in_wage_level_grade_2'

export const dataPointDefinition = {
  retracedId: 'num_of_female_wrkrs_in_wage_level_grade_2',
  name: 'Number of FEMALE workers in wage level Grade 4',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wage-13',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7720,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
